import _createForOfIteratorHelper from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function getCurves(_ref) {
  var size = _ref.size,
    thickness = _ref.thickness,
    sections = _ref.sections,
    renderRoundedLineCaps = _ref.renderRoundedLineCaps,
    rootColor = _ref.rootColor;
  var sum = sections.reduce(function (acc, current) {
    return acc + current.value;
  }, 0);
  var accumulated = Math.PI * ((size * 0.9 - thickness * 2) / 2) * 2;
  var offset = accumulated;
  var curves = [];
  var curvesInOrder = [];
  for (var i = 0; i < sections.length; i += 1) {
    curves.push({
      sum: sum,
      offset: offset,
      data: sections[i],
      root: false
    });
    offset -= sections[i].value / 100 * accumulated;
  }
  curves.push({
    sum: sum,
    offset: offset,
    data: {
      color: rootColor
    },
    root: true
  });
  curvesInOrder.push(__spreadProps(__spreadValues({}, curves[curves.length - 1]), {
    lineRoundCaps: false
  }));
  if (curves.length > 2) {
    curvesInOrder.push(__spreadProps(__spreadValues({}, curves[0]), {
      lineRoundCaps: renderRoundedLineCaps
    }));
    curvesInOrder.push(__spreadProps(__spreadValues({}, curves[curves.length - 2]), {
      lineRoundCaps: renderRoundedLineCaps
    }));
    for (var _i = 1; _i <= curves.length - 3; _i += 1) {
      curvesInOrder.push(__spreadProps(__spreadValues({}, curves[_i]), {
        lineRoundCaps: false
      }));
    }
  } else {
    curvesInOrder.push(__spreadProps(__spreadValues({}, curves[0]), {
      lineRoundCaps: renderRoundedLineCaps
    }));
  }
  return curvesInOrder;
}
export { getCurves };